import { toAbsoluteUrl } from "_metronic/helpers";
import { Config } from "../config/config";
import { jwtDecodingService } from "../services/jwt-decoding-service";

export class UserManagement {
    private static getAccessToken() {
        return localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string) as string
    }
    private static parseAccesToken() {
        return jwtDecodingService.getDecodedAccessToken(this.getAccessToken());
    }
    public static getAvatar() {
        const parsedAccessToken = this.parseAccesToken();
        return toAbsoluteUrl(`logo/${parsedAccessToken.accountId + ".png"}`)
    }
    public static getName() {
        const parsedAccessToken = this.parseAccesToken();
        return parsedAccessToken.given_name;
    }
    public static getFamilyName() {
        const parsedAccessToken = this.parseAccesToken();
        return parsedAccessToken.family_name;
    }
    public static getEmail() {
        const parsedAccessToken = this.parseAccesToken();
        return parsedAccessToken.email;
    }
    public static getLanguageId() {
        const parsedAccessToken = this.parseAccesToken();
        return parsedAccessToken.languageId;
    }
    public static getCulture() {
        const parsedAccessToken = this.parseAccesToken();
        return parsedAccessToken.culture;
    }
}